<template>
  <v-card width="250" :color="color" class="white--text drawerContainer">
    <v-card tile floating permanent clipped :color="color">
      <div class="hideBars drawerSet">
        <v-list tile :color="color" class="py-0 " dark>
          <v-list-item-title
            class="white--text subtitle-2 pa-2 orange--text">{{ formatDate(todayDate) }}</v-list-item-title>
          <v-list-group v-for="meeting in getFilteredMeetings(meetings.todaysMeetings)" :key="meeting.id" no-action>
            <template v-slot:activator>
              <v-list-item-content>
                <v-list-item-title class="white--text subtitle-1">{{ meeting.name }}</v-list-item-title>
              </v-list-item-content>
            </template>
            <v-list-item class="pl-4" style="background:#1565C0;border-bottom:1px solid #057faf"
              v-for="race in sortRaces(meeting.races)" :key="race.id" @click="clickRace(meeting, race.id)">
              <v-list-item-content>
                <v-badge :color="raceBubbleColor(race.status)" dot inline><v-list-item-title
                    class="white--text subtitle-2">Race {{ race.number }}</v-list-item-title></v-badge>
              </v-list-item-content>
            </v-list-item>
          </v-list-group>
        </v-list>
        <!--tomorrow-->
        <v-list tile :color="color" class="py-0 " dark>
          <v-list-item-title
            class="white--text subtitle-2 pa-2 orange--text">{{ formatDate(tomorrowDate) }}</v-list-item-title>
          <v-list-group v-for="meeting in getFilteredMeetings(meetings.tomorrowsMeetings)" :key="meeting.id" no-action>
            <template v-slot:activator>
              <v-list-item-content>
                <v-list-item-title class="white--text subtitle-1">{{ meeting.name }}</v-list-item-title>
              </v-list-item-content>
            </template>
            <v-list-item class="pl-4" style="background:#1565C0;border-bottom:1px solid #057faf"
              v-for="race in sortRaces(meeting.races)" :key="race.id" @click="clickRace(meeting, race.id)">
              <v-list-item-content>
                <v-badge :color="raceBubbleColor(race.status)" dot inline><v-list-item-title
                    class="white--text subtitle-2">Race {{ race.number }}</v-list-item-title></v-badge>
              </v-list-item-content>
            </v-list-item>
          </v-list-group>
        </v-list>
        <!--3rd day -->
        <v-list tile :color="color" class="py-0 " dark>
          <v-list-item-title
            class="white--text subtitle-2 pa-2 orange--text">{{ formatDate(thirdDate) }}</v-list-item-title>
          <v-list-group v-for="meeting in getFilteredMeetings(meetings.thirdsMeetings)" :key="meeting.id" no-action>
            <template v-slot:activator>
              <v-list-item-content>
                <v-list-item-title class="white--text subtitle-1">{{ meeting.name }}</v-list-item-title>
              </v-list-item-content>
            </template>
            <v-list-item class="pl-4" style="background:#1565C0;border-bottom:1px solid #057faf"
              v-for="race in sortRaces(meeting.races)" :key="race.id" @click="clickRace(meeting, race.id)">
              <v-list-item-content>
                <v-badge :color="raceBubbleColor(race.status)" dot inline><v-list-item-title
                    class="white--text subtitle-2">Race {{ race.number }}</v-list-item-title></v-badge>
              </v-list-item-content>
            </v-list-item>
          </v-list-group>
        </v-list>
      </div>
    </v-card>
  </v-card>
</template>

<script>
import { mapActions, mapState, mapGetters } from 'vuex'
import moment from 'moment'
import cloneDeep from 'clone-deep'

export default {
  name: "MeetingNavigation",
  data() {
    return {
      color: 'primary',
      todayDate: moment().startOf('day').format(),
      tomorrowDate: moment().startOf('day').add(1, 'd').format(),
      thirdDate: moment().startOf('day').add(2, 'd').format(),
      timerMeetings: null,
      timerRaces: null
    }
  },
  mounted() {
    this.fetchMeetingsList();
  },
  beforeUpdate() {
    if (this.signedIn === false) {
      this.cancelAutoUpdate();
    }
    if (this.signedIn === true && !this.timerMeetings) {
      this.timerMeetings = setInterval(this.fetchMeetingsList, 60000)
    }
  },
  beforeDestroy() {
    clearInterval(this.timerRaces)
    clearInterval(this.timerMeetings)
  },
  computed: {
    ...mapState(['nextToGoRaces', 'signedIn']),
    ...mapGetters(['getMeetings']),
    meetings() {
      return this.getMeetings || []
    }
  },
  methods: {
    ...mapActions(['selectMeeting', 'selectRace', 'mountNextToGo']),
    fetchMeetingsList() {
      this.$store.dispatch('loadMeetings', { todaysDate: this.todayDate, tomorrowsDate: this.tomorrowDate, thirdsDate: this.thirdDate });
    },
    cancelAutoUpdate() {
      clearInterval(this.timerRaces)
      clearInterval(this.timerMeetings)
      this.timerRaces = null, this.timerMeetings = null
    },
    async clickRace(meeting, race) {
      this.selectMeeting(meeting.id)
      //const nextToGoInMeeting = v.races.find(race => race.status === 'selling');
      this.selectRace(race.id)
    },
    sortRaces(races) {
      const sortedRaces = cloneDeep(races)
      return sortedRaces.sort(function (a, b) {
        return a.number - b.number;
      });
    },
    getFilteredMeetings(filteredMeetings) {
      return filteredMeetings.filter(meeting => meeting.type === 'R' && meeting.fixedOddsEnabled === true)
    },
    getNtgFilteredMeetings(filteredNtgRaces) {
      return filteredNtgRaces.filter(race => race.type === 'R')
    },
    formatDate: function (date) {
      return moment(date, 'YYYY-MM-DD').format('LL');
    },
    formatDateNtg: function (date) {
      return moment(date, 'YYYY-MM-DD HH:mm').fromNow('ss');
    },
    raceBubbleColor: function (raceStatus) {
      if (raceStatus === 'paid') {
        return '#333'
      } else if (raceStatus === 'selling') {
        return 'success'
      } else if (raceStatus === 'abandoned') {
        return 'red'
      } else if (raceStatus === 'closed') {
        return '#333'
      } else if (raceStatus === 'interim') {
        return 'warning'
      }
    },
  },


}
</script>

<style scoped>
.drawerContainer {
  max-height: 87vh;
  position: fixed
}

.drawerSpacer {
  background: #fff;
  height: 1px;
  width: 100%;
}

.drawerSet {
  max-height: 88vh;
  overflow: scroll
}</style>
